module.exports = __webpack_public_path__ + "img/fleche2-responsive.49c568a5.svg";